export default "__VITE_ASSET__BxynOv4M__"